import { isPastDate, isPastDateWithTZ } from 'srcReact/helpers/datetimeHelper'
import { checkNested } from 'srcReact/helpers/validator'
import { mixrConstants as mc } from './constants'
import { commonConstants } from 'srcReact/components'
import { profileConstants } from 'srcReact/MyProfile/constant'

// To retrieve a newly created event from local storage
const createdMixrId = JSON.parse(localStorage.getItem('created_mixr_id'))
const createdMixrUrl = JSON.parse(localStorage.getItem('created_mixr_url'))

const initialState = {
  mainLoading: false,
  membersLoading: false,

  mixr: {
    is_preview: false,
    createMixrType: 'plan',
    attendance_limits: [],
    attending_type: 'in_person',
    createMixrLoading: false,
    isAdvanceSettingsVisible: false,
    recurrence: {
      type: 'none'
    }
  },
  participants: [],
  participantsStats: null,
  users: [],
  usersStat: null,
  staff: [],
  staffStat: null,
  searchMember: '',
  searchedMemberError: null,
  pictures: [],
  documents: [],
  deleteFileLoading: false,
  serverErrors: [],
  userAfterChangedRole: null,
  cancelMixrLoading: false,
  mixrCancelled: false,
  loadingFeeds: false,
  feeds: [],
  feedsStats: null,
  newsFeedId: 0,
  loadingSendMessage: false,
  isMessagePosted: false,
  reactionProcessing: false,
  reactionToProcess: null,
  deleteMessageLoading: false,
  isMessageDeleted: false,
  loadingEditMessage: false,
  isMessageEdited: false,
  usersInFeed: [],
  originMessageId: 0,
  joinGroup: {
    joinedGroup: '',
    loading: false
  },
  widgets: null,
  loadingMedias: false,
  message_draft: null,
  moderation_info: {
    flagged_posts: 0,
    moderation_id: 0,
    is_suspended: false
  },
  memberRole: {
    userId: 0,
    type: '', //add/remove
    role: '',
    success: false
  },
  saveDraft: {
    loading: false,
    success: false,
    error: null
  },
  deleteDraft: {
    loading: false,
    success: false,
    error: null
  },
  drafts: {
    list: [],
    stats: null,
    loading: false,
    error: ''
  },
  existingMixrs: {
    list: [],
    stats: null,
    loading: false,
    error: ''
  },
  usersToInvite: {
    list: [],
    loading: false,
    error: null,
    stats: null
  },
  invitation: {
    sending: false,
    sent: false,
    error: false,
    data: []
  },
  rating: {
    loadig: false,
    data: {
      ratings_and_reviews: {}
    },
    error: '',
    success: false
  },

  // To set createdMixrId and createdMixrUrl for a newly created event from local storage, especially for a native app
  createdMixrId: createdMixrId ? createdMixrId : '',
  createdMixrUrl: createdMixrUrl ? createdMixrUrl : ''
}
export function mixr(state = initialState, action) {
  const { response } = action
  switch (action.type) {
    case mc.SET_MIXR_ROLE:
      return {
        ...state,
        mixr: {
          ...state.mixr,
          logged_user: {
            ...state.mixr.logged_user,
            group_role: action.joinedGroup.user_group_role,
            group_attending: action.joinedGroup.user_attending_status
          }
        }
      }
    case mc.SET_ATTENDING_TYPE:
      return {
        ...state,
        attending: action.attending
      }

    case mc.GET_MIXR_DETAIL_REQUEST:
      return {
        ...state,
        mainLoading: true,
        mixrCancelled: false
      }
    case mc.GET_MIXR_DETAIL_SUCCESS:
      if (action.response) {
        const { mixr, staff, participants, widgets, moderation_info, rating } = action.response
        return {
          ...state,
          mixr: mixr,
          mainLoading: false,
          participants: participants ? participants.users : [],
          participantsStats: participants && participants.stats,
          pictures: mixr && mixr.featured_files && mixr.featured_files.pictures,
          documents: mixr && mixr.featured_files && mixr.featured_files.documents,
          staff: staff && staff.users,
          staffStat: staff && staff.stats,
          widgets: widgets,
          rating: {
            ...state.rating,
            data: rating
          },
          moderation_info: {
            ...state.moderation_info,
            ...moderation_info
          }
        }
      } else {
        return { ...state }
      }
    case mc.GET_MIXR_DETAIL_FAILURE:
      return {
        ...state,
        mainLoading: false,
        serverErrors: action.error
      }

    case mc.GET_USERS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        membersLoading: true,
        searchedMemberError: null,
        searchTerm: '',
        users: isPagination ? [...state.users] : [],
        usersStat: isPagination ? { ...state.usersStat } : {}
      }
    }
    case mc.GET_USERS_SUCCESS: {
      const { search, scope, isPagination } = action.updatedResponse
      let updatedList = [...state.users]
      let responseUsers = {}
      if (scope === 'all') {
        responseUsers = action.updatedResponse.all
      } else if (scope === 'participants') {
        responseUsers = action.updatedResponse.participants
      } else if (scope === 'staff') {
        responseUsers = action.updatedResponse.staff
      } else if (scope === 'not_going') {
        responseUsers = action.updatedResponse.not_going
      } else if (scope === 'invited_all') {
        responseUsers = action.updatedResponse.invited_all
      } else if (scope === 'invited_no_reply') {
        responseUsers = action.updatedResponse.invited_no_reply
      } else if (scope === 'invited_not_going') {
        responseUsers = action.updatedResponse.invited_not_going
      } else if (scope === 'invited_going') {
        responseUsers = action.updatedResponse.invited_going
      }
      if (isPagination && responseUsers.users) {
        updatedList = [...state.users, ...responseUsers.users]
      } else if (search.length >= 2 || search.length === 0 || state.users.length === 0) {
        updatedList = responseUsers.users ? [...responseUsers.users] : []
      }
      return {
        ...state,
        users: updatedList,
        usersStat: responseUsers.stats && { ...responseUsers.stats },
        searchedMemberError: null,
        searchTerm: search,
        membersLoading: false,
        staff: scope === 'staff' && updatedList,
        staffStat: scope === 'staff' && responseUsers.stats && { ...responseUsers.stats }
      }
    }
    case mc.GET_USERS_FAILURE:
      return {
        ...state,
        searchedMemberError: action.error,
        searchTerm: '',
        membersLoading: action.error && action.error.cancelError ? true : false,
        serverErrors: action.error
      }
    case mc.DELETE_FILE_REQUEST:
      return {
        ...state,
        deleteFileLoading: true
      }
    case mc.DELETE_FILE_SUCCESS:
      if (action.response) {
        const { mixr } = action.response
        return {
          ...state,
          deleteFileLoading: false,
          pictures: mixr && mixr.featured_files && mixr.featured_files.pictures,
          documents: mixr && mixr.featured_files && mixr.featured_files.documents
          // participants: participants,
          // staff: staff,
        }
      } else {
        return { ...state }
      }

    case mc.DELETE_FILE_FAILURE:
      return {
        ...state,
        deleteFileLoading: false,
        serverErrors: action.error
      }

    case mc.UPDATE_RSVP_DATA: {
      return {
        ...state,
        mixr: {
          ...state.mixr,
          logged_user: {
            ...state.mixr.logged_user,
            mixr_attending: action.rsvpData.attending,
            group_role: action.rsvpData.group_role || 'none',
            is_invited: 0
          }
        }
      }
    }

    case mc.ADD_STAFF_ROLE_REQUEST:
    case mc.REMOVE_STAFF_ROLE_REQUEST: {
      return {
        ...state,
        memberRole: {
          ...state.memberRole,
          success: false
        }
      }
    }
    case mc.ADD_STAFF_ROLE_SUCCESS:
    case mc.REMOVE_STAFF_ROLE_SUCCESS: {
      const { scope, actionType } = action
      const { user_id, user_mixr_role } = action.response
      let usersToUpdate = [...state.users]
      let usersInFeedToUpdate = [...state.usersInFeed]
      //for participants tab
      for (let i = 0; i < usersToUpdate.length; i++) {
        if (usersToUpdate[i].id == user_id) {
          usersToUpdate[i].role = user_mixr_role
        }
      }
      //for feeds tab
      if (usersInFeedToUpdate.length > 0) {
        for (let i = 0; i < usersInFeedToUpdate.length; i++) {
          if (usersInFeedToUpdate[i].id == user_id) {
            usersInFeedToUpdate[i].role = user_mixr_role
          }
        }
      }
      const updatedGetToMeet = checkNested(state, 'widgets', 'get_to_meet')
        ? state.widgets.get_to_meet.map((x) => {
            if (x.id == user_id) {
              x.role = user_mixr_role
            }
            return x
          })
        : []

      const updatedWidgetParticipants = checkNested(state, 'widgets', 'participants', 'participants_random_order')
        ? state.widgets.participants.participants_random_order.map((x) => {
            if (x.id == user_id) {
              x.role = user_mixr_role
            }
            return x
          })
        : []
      return {
        ...state,
        users:
          scope === 'staff'
            ? usersToUpdate.filter((u) => u.role === 'organizer' || u.role === 'co-organizer')
            : [...usersToUpdate], //for participants tab
        usersInFeed: [...usersInFeedToUpdate], //for feeds tab
        userAfterChangedRole: { ...action.response },
        memberRole: {
          userId: user_id,
          role: user_mixr_role,
          type: actionType,
          success: true
        },
        widgets: {
          ...state.widgets,
          get_to_meet: updatedGetToMeet,
          participants: {
            ...state.widgets.participants,
            participants_random_order: updatedWidgetParticipants
          }
        }
      }
    }
    case mc.ADD_STAFF_ROLE_FAILURE:
    case mc.REMOVE_STAFF_ROLE_FAILURE: {
      return {
        ...state,
        serverErrors: action.error,
        memberRole: {
          ...state.memberRole,
          success: false
        }
      }
    }

    case mc.CANCEL_MIXR_REQUEST:
      return {
        ...state,
        cancelMixrLoading: true
      }
    case mc.CANCEL_MIXR_SUCCESS:
      return {
        ...state,
        cancelMixrLoading: false,
        mixrCancelled: true
      }

    case mc.CANCEL_MIXR_FAILURE:
      return {
        ...state,
        serverErrors: action.error,
        cancelMixrLoading: false
      }

    case mc.JOIN_GROUP_REQUEST: {
      return {
        ...state,
        joinGroup: {
          loading: true,
          joinedGroup: ''
        }
      }
    }
    case mc.JOIN_GROUP_SUCCESS: {
      return {
        ...state,
        joinGroup: {
          loading: false,
          joinedGroup: action.response.user_attending_status
        },
        mixr: {
          ...state.mixr,
          logged_user: {
            ...state.mixr.logged_user,
            group_attending: action.response.user_attending_status
          }
        }
      }
    }
    case mc.JOIN_GROUP_FAILURE: {
      return {
        ...state,
        serverErrors: action.error,
        joinGroup: {
          loading: false,
          joinedGroup: ''
        }
      }
    }

    case mc.GET_MEDIA_REQUEST: {
      return {
        ...state,
        loadingMedias: true
      }
    }
    case mc.GET_MEDIA_SUCCESS: {
      const { mixr } = action.response

      return {
        ...state,
        pictures: mixr && mixr.featured_files && mixr.featured_files.pictures,
        documents: mixr && mixr.featured_files && mixr.featured_files.documents,
        loadingMedias: false
      }
    }
    case mc.GET_MEDIA_FAILURE: {
      return {
        ...state,
        loadingMedias: false
      }
    }

    case mc.SET_PREVIEW_MIXR_DATA: {
      let updatedMixr = initialState.mixr
      if (action.mixrData) {
        const mixr = action.mixrData

        if (action.mixrData.draft_id && action.mixrData.draft_id > 0) {
          const isPastStartDate = mixr.location?.timezone
            ? isPastDateWithTZ(mixr.start_at, mixr.location?.timezone)
            : isPastDate(mixr.start_at, 'string')
          const isPastEndDate = mixr.location?.timezone
            ? isPastDateWithTZ(mixr.end_at, mixr.location?.timezone)
            : isPastDate(mixr.end_at, 'string')
          const isPastUntilDate = mixr.location?.timezone
            ? isPastDateWithTZ(mixr?.recurrence?.end_date, mixr.location?.timezone)
            : isPastDate(mixr?.recurrence?.end_date, 'string')
          updatedMixr = {
            ...mixr,
            createMixrType: 'plan',
            is_preview: true,
            preview_in_modal: action.previewInModal,
            status: 'planned',
            name: mixr.name,
            description: mixr.description,
            fees: mixr.fees,
            local_start_at: isPastStartDate && !action.previewInModal ? '' : mixr.start_at,
            local_end_at: isPastEndDate && !action.previewInModal ? '' : mixr.end_at,
            additional_information: mixr.additional_information,
            local_invite_send_date: mixr.invite_send_date || mixr.local_invite_send_date,
            logged_user: {
              mixr_attending: mixr.attending_type === 'virtual' ? 'virtual' : 'in_person',
              mixr_role: 'organizer',
              group_attending: 'joined',
              group_role: mixr.group.group_role
            },
            recurrence: {
              ...mixr.recurrence,
              end_date: isPastUntilDate && !action.previewInModal ? '' : mixr?.recurrence?.end_date
            },
            participants: {
              going: {
                total: 1,
                in_person: mixr.attending_type === 'in_person' || mixr.attending_type === 'both' ? 1 : 0,
                virtual: mixr.attending_type === 'virtual' || mixr.attending_type === 'both' ? 1 : 0
              },
              invited: {
                all: 1,
                no_reply: 0,
                not_going: 0,
                going: 1
              },
              staff: 1
            }
          }
        } else {
          const isPastStartDate = isPastDateWithTZ(mixr.local_start_at, mixr.location?.timezone)
          const isPastEndDate = isPastDateWithTZ(mixr.local_end_at, mixr.location?.timezone)
          const isPastUntilDate = isPastDateWithTZ(mixr?.recurrence?.end_date, mixr.location?.timezone)
          const updateMixrData = {
            ...mixr,
            local_start_at: isPastStartDate && !action.previewInModal ? '' : mixr.local_start_at,
            local_end_at: isPastEndDate && !action.previewInModal ? '' : mixr.local_end_at,
            recurrence: {
              ...mixr.recurrence,
              end_date: isPastUntilDate && !action.previewInModal ? '' : mixr?.recurrence?.end_date,
              weeks_count:
                (mixr.recurrence.type === 'weekly' && mixr.recurrence.interval) || mixr.recurrence.weeks_count,
              months_count:
                (mixr.recurrence.type === 'monthly' && mixr.recurrence.interval) || mixr.recurrence.months_count
            }
          }

          updatedMixr = {
            ...updateMixrData,
            is_preview: true,
            preview_in_modal: action.previewInModal,
            status: 'planned'
          }
        }
      }
      return {
        ...state,
        mainLoading: false,
        mixr: updatedMixr,
        staff: [action.user],
        users: [action.user]
      }
    }
    case mc.CLEAR_CREATED_MIXR_VALUES: {
      return {
        ...initialState
      }
    }
    case mc.RESET_EDIT_SUCCESS_FLAG: {
      return {
        ...state,
        editSuccess: false
      }
    }

    case mc.GET_FEE_CATEGORIES_REQUEST:
      return {
        ...state
      }
    case mc.GET_FEE_CATEGORIES_SUCCESS:
      const { categories } = action.response
      return {
        ...state,
        feesCategories: categories
      }
    case mc.GET_FEE_CATEGORIES_FAILURE:
      return {
        ...state
      }

    case mc.GET_RECUR_END_DATE_REQUEST:
      return {
        ...state,
        recurEndDateError: [],
        loadingGetMixrEndDate: true
      }
    case mc.GET_RECUR_END_DATE_SUCCESS:
      return {
        ...state,
        endMixrData: response,
        recurrentMixrsCount: response.recurrent_events_count,
        loadingGetMixrEndDate: false,
        mixr: {
          ...state.mixr,
          recurrence: {
            ...state.mixr.recurrence,
            events: response.events.filter((x) => x.will_be_created === 1),
            errorMessage: response.error_message
          }
        }
      }
    case mc.GET_RECUR_END_DATE_FAILURE:
      return {
        ...state,
        recurEndDateError: action.error ? action.error.message : [],
        loadingGetMixrEndDate: false
      }
    case mc.CREATE_MIXR_REQUEST:
      return {
        ...state,
        createUpdateErrors: [],
        mixr: {
          ...state.mixr,
          createMixrLoading: true
        }
      }
    case mc.CREATE_MIXR_SUCCESS: {
      const { mixr } = response
      return {
        ...state,
        createdMixrId: mixr.id,
        createdMixrUrl: mixr.url,
        createdMixrName: mixr.name,
        createUpdateErrors: [],
        mixr: {
          ...state.mixr,
          createMixrLoading: false,
          is_preview: false
        }
      }
    }
    case mc.CREATE_MIXR_FAILURE:
      return {
        ...state,
        createUpdateErrors: action.error,
        mixr: {
          ...state.mixr,
          createMixrLoading: false
        }
      }
    case mc.EDIT_MIXR_REQUEST:
      return {
        ...state,
        editLoading: true,
        editSuccess: false,
        createUpdateErrors: []
      }
    case mc.EDIT_MIXR_SUCCESS: {
      const { mixr } = response
      return {
        ...state,
        editLoading: false,
        editSuccess: true,
        mixr: response.mixr,
        createUpdateErrors: []
      }
    }
    case mc.EDIT_MIXR_FAILURE:
      return {
        ...state,
        editLoading: false,
        editSuccess: false,
        createUpdateErrors: action.error
      }

    case mc.CLEAR_RECUR_END_DATE_ERROR: {
      return {
        ...state,
        recurEndDateError: []
      }
    }

    case mc.SET_INVITE_INFO: {
      return {
        ...state,
        inviteInfo: {
          isScheduled: action.inviteInfo.isScheduled,
          datetime: action.inviteInfo.datetime
        }
      }
    }

    case mc.SET_MIXR_DATA_BY_KEY: {
      const { arrKeyValue } = action
      let properties = {}
      let isPreview = false
      let users = []
      let staff = []
      for (let i = 0; i < arrKeyValue.length; i++) {
        if (arrKeyValue[i].key === 'is_preview') {
          //indicates the last step where we redirect to mixr page. If it is last step, store the whole obj in local storage
          isPreview = true
        }
        if (arrKeyValue[i].key === 'users') {
          users = arrKeyValue[i].value
        }
        if (arrKeyValue[i].key === 'staff') {
          staff = arrKeyValue[i].value
        }
        properties[arrKeyValue[i].key] = arrKeyValue[i].value
      }
      const mixrData = {
        ...state.mixr,
        ...properties,
        users: users,
        staff: staff
      }
      if (isPreview) {
        localStorage.setItem('mixr_preview', JSON.stringify(mixrData))
      }
      return {
        ...state,
        mixr: { ...mixrData },
        users: users,
        staff: staff
      }
    }

    // case mc.TRANSLATE_MESSAGE_REQUEST:
    //   return {
    //     ...state
    //   }
    // case mc.TRANSLATE_MESSAGE_SUCCESS: {
    //   const { response, messageId } = action
    //   const updatedFeeds = getUpdatedTranslatedFeeds(state.feeds, messageId, response)
    //   return {
    //     ...state,
    //     feeds: updatedFeeds
    //   }
    // }
    // case mc.TRANSLATE_MESSAGE_FAILURE:
    //   return {
    //     ...state
    //   }

    case mc.SAVE_DRAFT_REQUEST:
      return {
        ...state,
        saveDraft: {
          ...state.saveDraft,
          loading: true
        }
      }
    case mc.SAVE_DRAFT_SUCCESS: {
      return {
        ...state,
        saveDraft: {
          ...state.saveDraft,
          loading: false,
          success: true,
          error: null
        }
      }
    }
    case mc.SAVE_DRAFT_FAILURE:
      return {
        ...state,
        saveDraft: {
          ...state.saveDraft,
          loading: false,
          error: action.error,
          success: false
        }
      }
    case mc.RESET_SAVE_DRAFT: {
      return {
        ...state,
        mixr: initialState.mixr,
        saveDraft: initialState.saveDraft
      }
    }
    case mc.RESET_SAVE_DRAFT_ERROR: {
      return {
        ...state,
        saveDraft: initialState.saveDraft
      }
    }
    case mc.GET_DRAFTS_REQUEST:
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: true
        }
      }
    case mc.GET_DRAFTS_SUCCESS: {
      const { search, pagination } = action
      const { draft_events, draft_stats } = action.response
      const newDraftList = pagination.isPagination ? [...state.drafts.list, ...draft_events] : draft_events
      return {
        ...state,
        drafts: {
          ...state.drafts,
          list: newDraftList,
          stats: draft_stats,
          loading: false
        }
      }
    }
    case mc.GET_DRAFTS_FAILURE:
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          error: action.error
        }
      }

    case mc.GET_DRAFT_DATA_REQUEST:
      return {
        ...state
      }
    case mc.GET_DRAFT_DATA_SUCCESS: {
      return {
        ...state,
        mixr: action.response.draft_event
      }
    }
    case mc.GET_DRAFT_DATA_FAILURE:
      return {
        ...state
      }

    case mc.DELETE_DRAFT_REQUEST:
      return {
        ...state,
        deleteDraft: {
          ...state.deleteDraft,
          loading: true
        }
      }
    case mc.DELETE_DRAFT_SUCCESS: {
      const { draft_id } = action.response
      const updatedDrafts = state.drafts.list.filter((x) => x.draft_id != draft_id)
      return {
        ...state,
        drafts: {
          ...state.drafts,
          list: updatedDrafts
        },
        deleteDraft: {
          ...state.deleteDraft,
          success: true,
          loading: false,
          error: ''
        }
      }
    }
    case mc.DELETE_DRAFT_FAILURE:
      return {
        ...state,
        deleteDraft: {
          ...state.deleteDraft,
          success: false,
          loading: false,
          error: action.error
        }
      }

    case mc.GET_EXISTING_MIXRS_REQUEST:
      return {
        ...state,
        existingMixrs: {
          ...state.existingMixrs,
          loading: true
        }
      }
    case mc.GET_EXISTING_MIXRS_SUCCESS: {
      const { search, pagination } = action
      const { mixrs, mixr_stats } = action.response
      const newMixrList = pagination.isPagination ? [...state.existingMixrs.list, ...mixrs] : mixrs
      return {
        ...state,
        existingMixrs: {
          ...state.existingMixrs,
          list: newMixrList,
          stats: mixr_stats,
          loading: false
        }
      }
    }
    case mc.GET_EXISTING_MIXRS_FAILURE:
      return {
        ...state,
        existingMixrs: {
          ...state.existingMixrs,
          loading: false,
          error: action.error
        }
      }

    case mc.SET_PREVIEW_FROM_MODAL_FLAG: {
      return {
        ...state,
        mixr: {
          ...state.mixr,
          preview_in_modal: action.isSet
        }
      }
    }

    case mc.GET_USERS_TO_INVITE_REQUEST: {
      const { pagination } = action
      return {
        ...state,
        usersToInvite: {
          ...state.usersToInvite,
          loading: true,
          list: pagination.isPagination ? [...state.usersToInvite.list] : [],
          stats: pagination.isPagination ? { ...state.usersToInvite.stats } : {}
        }
      }
    }
    case mc.GET_USERS_TO_INVITE_SUCCESS: {
      const { pagination, search } = action
      const { suggested_members, mixr } = action.response

      let updatedList = [...state.usersToInvite.list]
      if (pagination.isPagination && suggested_members.users) {
        updatedList = [...state.usersToInvite.list, ...suggested_members.users]
      } else if (search.length >= 2 || search.length === 0 || state.usersToInvite.list.length === 0) {
        updatedList = suggested_members.users ? [...suggested_members.users] : []
      }

      return {
        ...state,
        mixr: mixr,
        usersToInvite: {
          ...state.usersToInvite,
          list: updatedList,
          stats: suggested_members.stats,
          loading: false
        }
      }
    }
    case mc.GET_USERS_TO_INVITE_FAILURE:
      return {
        ...state,
        usersToInvite: {
          ...state.usersToInvite,
          loading: action.error && action.error.cancelError ? true : false,
          error: action.error
        }
      }
    case mc.SHOW_ADVANCE_SETTING:
      return {
        ...state,
        mixr: {
          ...state.mixr,
          isAdvanceSettingsVisible: true
        }
      }
    case commonConstants.GET_TIMEZONE_BY_LAT_LONG_SUCCESS: {
      return {
        ...state,
        mixr: {
          ...state.mixr,
          location: {
            ...state.mixr.location,
            timezone: response
          }
        }
      }
    }

    case mc.SET_INITIAL_STATE: {
      return {
        ...initialState
      }
    }
    case profileConstants.ADD_INTEREST_SUCCESS: {
      const updatedInterests = state.mixr?.interests?.map((interest) => {
        if (action.response.find((x) => x.id === interest.id)) {
          interest.is_common_with_logged_user = 1
        }
        return interest
      })

      return {
        ...state,
        mixr: {
          ...state.mixr,
          interests: updatedInterests
        }
      }
    }
    // Send invites
    case mc.SEND_INVITES_REQUEST:
      return {
        ...state,
        invitation: { ...state.invitation, sending: true, sent: false, error: false }
      }
    case mc.SEND_INVITES_SUCCESS: {
      return {
        ...state,
        invitation: {
          ...state.invitation,
          sending: false,
          sent: true,
          error: false,
          data: action.response.users
        }
      }
    }
    case mc.SEND_INVITES_FAILURE: {
      return {
        ...state,
        invitation: { ...state.invitation, sending: false, sent: false, error: true, data: [] }
      }
    }

    // mixr rating
    case mc.UPDATE_MIXR_RATING_REQUEST:
      return {
        ...state,
        rating: {
          ...state.rating,
          loading: true,
          success: false
        }
      }
    case mc.UPDATE_MIXR_RATING_SUCCESS: {
      const { fromMixrPage } = action
      const { mixr_rating, ratings_and_reviews } = action.response
      if (fromMixrPage) {
        let updatedUserRatings = []
        if (state.rating?.data?.ratings_and_reviews?.user_ratings?.length > 0) {
          const existingUserReview = state.rating.data.ratings_and_reviews.user_ratings.find(
            (user) => user.id === ratings_and_reviews.user_ratings[0].id
          )
          if (existingUserReview) {
            updatedUserRatings = state.rating.data.ratings_and_reviews.user_ratings.map((u) => {
              if (u.id === existingUserReview.id) {
                u = ratings_and_reviews.user_ratings[0]
              }
              return u
            })
          } else {
            updatedUserRatings = ratings_and_reviews.user_ratings
          }
        } else {
          updatedUserRatings = ratings_and_reviews.user_ratings
        }

        return {
          ...state,
          rating: {
            ...state.rating,
            loading: false,
            success: true,
            error: '',
            data: {
              ...state.rating.data,
              mixr_rating: mixr_rating,
              ratings_and_reviews: {
                ...state.rating.data.ratings_and_reviews,
                rating_count: ratings_and_reviews.rating_count,
                review_count: ratings_and_reviews.review_count,
                user_ratings: updatedUserRatings
              }
            }
          }
        }
      } else {
        return {
          ...state,
          rating: {
            ...state.rating,
            loading: false,
            success: true,
            error: ''
          }
        }
      }
    }
    case mc.UPDATE_MIXR_RATING_FAILURE: {
      return {
        ...state,
        rating: {
          ...state.rating,
          loading: false,
          success: false,
          error: Array.isArray(action.error) && action.error.length > 0 ? action.error[0] : action.error
        }
      }
    }

    case mc.GET_MORE_REVIEWS_REQUEST: {
      return {
        ...state,
        rating: {
          ...state.rating,
          loading: true
        }
      }
    }
    case mc.GET_MORE_REVIEWS_SUCCESS: {
      const { rating } = action.response
      return {
        ...state,
        rating: {
          ...state.rating,
          data: {
            ...state.rating.data,
            ratings_and_reviews: {
              ...state.rating.data.ratings_and_reviews,
              stats: rating.ratings_and_reviews.stats,
              user_ratings: [
                ...state.rating.data.ratings_and_reviews.user_ratings,
                ...rating.ratings_and_reviews.user_ratings
              ]
            }
          }
        }
      }
    }
    case mc.GET_MORE_REVIEWS_FAILURE: {
      return {
        ...state,
        rating: {
          ...state.rating,
          error: action.error
        }
      }
    }

    default:
      return state
  }
}
